import axios from "axios";
import { config } from "../config";

const getChatbotResponse = async (
  message: string,
  accessToken: string,
  userId: string
): Promise<any> => {
  try {
    // if (config.environment === "development") {
    //   const files = [
    //     "chatResponse.json",
    //   ];
    //   const response = await axios.get(
    //     `/inputs/${files[Math.floor(Math.random() * files.length)]}`
    //   );
    //   return response.data;
    // }

    const apiUrl = `${config.baseUrl}/api/chatbot/query`;
    const response = await axios.post(
      apiUrl,
      {
        "messages": [
          {
            "role": "user",
            "content": message
          }
        ],
        "user_id": userId
      },
      {
        headers: {
          "Authorization": `Bearer ${accessToken}`
        }
      }
    );

    if (!response || !response.data) {
      throw new Error("Empty response from chatbot");
    }

    return response.data;
  } catch (error) {
    return {
      sources: [],
      response: config.errorResponseMessage,
    };
  }
};

export { getChatbotResponse };
